import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { useCrud } from '@/hooks/useCrud'
import { camelToWords } from '@/utils/stringHelper'
import OfferService from '../offer.service'
import { isNullish } from '@/utils/helper'

const useOffer = () => {
  const service = new OfferService()
  const baseCrud = useCrud(API_RESOURCE.OFFER, service)
  const queryClient = useQueryClient()

  const useImportOffer = () => {
    return useMutation({
      mutationFn: service.importOffer,
      onSuccess: (res) => {
        toast.info(`Successfully Import ${camelToWords(API_RESOURCE.OFFER)}`)
        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const usePatchOffer = useAction({
    mutationFn: service.patchOffer,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Patch Offer',
    shouldRefresh: false,
  })

  const useUploadOffers = useAction({
    mutationFn: service.uploadOffers,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Upload Offer',
  })
  const useBatchUpdateOffers = useAction({
    mutationFn: service.batchUpdateOffers,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Batch Update  Offer',
  })

  const useGetMergedDocument = () => {
    return useMutation({
      mutationFn: service.getMergedDocument,
    })
  }

  const useGetHandoverFormDocument = (offerId) => {
    return useMutation({
      mutationFn: () => service.getHandoverFormDocument(offerId),
    })
  }

  const useGetAllOfferRevisions = (offerId) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.detail(offerId), 'offerRevisions'],
      queryFn: () => service.getAllOfferRevisions({ offerId }),
      enabled: !isNullish(offerId),
    })
  }

  const useCloseOffer = useAction({
    mutationFn: service.closeOffer,
    queryKey: baseCrud.queryKey,
    message: 'Offer Closed',
  })

  const useSaveOfferBooking = useAction({
    mutationFn: service.saveBooking,
    queryKey: baseCrud.queryKey,
    message: 'Booking Saved',
  })

  const useGetSharepointDocumentLinks = (offerId) => {
    return useQuery({
      queryKey: [offerId],
      queryFn: () => service.getSharepointDocumentLinks(offerId),
      enabled: !isNullish(offerId),
    })
  }

  return {
    useFetchAllOffers: baseCrud.useFetchAll,
    useCreateOffer: baseCrud.useCreate,
    useFetchOffer: baseCrud.useFetchOne,
    useUpdateOffer: baseCrud.useUpdate,
    useRemoveOffer: baseCrud.useRemove,

    useImportOffer,

    //Extra
    usePatchOffer,
    useUploadOffers,
    useBatchUpdateOffers,
    useGetAllOfferRevisions,
    useGetMergedDocument,
    useCloseOffer,
    useGetHandoverFormDocument,
    useSaveOfferBooking,
    useGetSharepointDocumentLinks,
  }
}

export default useOffer
